import React, {useCallback, useEffect, useMemo} from 'react';
import './App.css';
import { Routes as AppRoutes } from "./routes"
import { BrowserRouter as Router, Routes, Route, Outlet, Navigate } from 'react-router-dom';
import LoginPage from "./features/login/LoginPage";
import Footer from "./components/layout/footer/Footer";
import ForgotPassword from "./features/forgotPassword/ForgotPassword";
import { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import Header from "./components/layout/header/Header";
import { isTokenExpired } from "./helpers/utils/AccessControlUtils";
import Users from './features/user/users/Users';
import CreateUser from './features/user/users/CreateUser';
import SideBar from './components/layout/sidebar/SideBar';
import UpdateUser from "./features/user/users/UpdateUser";
import { useDispatch, useSelector } from "react-redux";
import Roles from './features/user/roles/Roles';
import Teams from "./features/user/teams/Teams";
import Customers from "./features/customer/Customers";
import CannedNotes from "./features/data/cannedNotes/CannedNotes";
import Counties from "./features/data/counties/Counties";
import MetroAreas from "./features/data/metroAreas/MetroAreas";
import Profile from "./features/profile/Profile";
import SystemProperties from "./features/sysAdmin/systemProperties/SystemProperties";
import UpdateSystemProperty from "./features/sysAdmin/systemProperties/UpdateSystemProperty";
import CreateCustomerForm from './features/customer/CreateCustomerForm';
import CustomerDetailPage from './features/customer/CustomerDetailPage';
import BranchDetailPage from './features/customer/branch/BranchDetailPage';
import FollowUpTypes from "./features/tenantAdmin/followUpTypes/FollowUpTypes";
import CreateFollowUpType from "./features/tenantAdmin/followUpTypes/CreateFollowUpType";
import UpdateFollowUpType from "./features/tenantAdmin/followUpTypes/UpdateFollowUpType";
import States from "./features/data/states/States";
import CreateState from "./features/data/states/CreateState";
import UpdateState from "./features/data/states/UpdateState";
import UpdateCannedNote from "./features/data/cannedNotes/UpdateCannedNote";
import CreateRole from './features/user/roles/CreateRole';
import UpdateRole from './features/user/roles/UpdateRole';
import CreateCounty from "./features/data/counties/CreateCounty";
import UpdateCounty from "./features/data/counties/UpdateCounty";
import CreateTeam from "./features/user/teams/CreateTeam";
import TeamDetailPage from "./features/user/teams/TeamDetailPage";
import RevenueEvents from "./features/accounting/revenueEvents/RevenueEvents";
import VendorPricing from "./features/accounting/vendorPricing/VendorPricing";
import CreateVendorPricing from "./features/accounting/vendorPricing/CreateVendorPricing";
import UpdateVendorPricing from "./features/accounting/vendorPricing/UpdateVendorPricing";
import CreateMetroArea from "./features/data/metroAreas/CreateMetroArea";
import UpdateMetroArea from "./features/data/metroAreas/UpdateMetroArea";
import ResetPassword from "./features/resetPassword/ResetPassword";
import ErrorPage from "./components/common/ErrorPage";
import { clearGlobalError, setRedirectPath } from './app/globalSlice/globalSlice';
import VerifyMfaForm from "./features/login/modal/VerifyMfaForm";
import AppraisalRoll from "./features/data/appraisalRoll/templates/AppraisalRoll";
import AppraisalRollDetailPage from "./features/data/appraisalRoll/templates/AppraisalRollDetailPage";
import BillReleases from "./features/data/billRelease/BillReleases";
import CreateBillRelease from "./features/data/billRelease/CreateBillRelease";
import UpdateBillRelease from "./features/data/billRelease/UpdateBillRelease";
import LinkedAccounts from "./features/data/linkedAccounts/LinkedAccounts";
import HighRiskAccountVerified from "./features/data/hIghRiskAccountVerified/HighRiskAccountVerified";
import CollectorLink from "./features/data/collectorLink/CollectorLink";
import Collectors from './features/data/collector/templates/Collectors';
import StateCodes from './features/data/stateCode/templates/StateCodes';
import ReportsHistory from './features/reports/report-history/templates/ReportHistory';
import OrderEvent from './features/reports/orderEvents/templates/OrderEvent';
import CountyReport from './features/reports/reports/templates/CountyReport';
import Associations from './features/hoa/association/templates/Association';
import ManagementCompany from './features/hoa/managementCompany/template/ManagementCompany';
import AutoHoa from './features/hoa/auto-hoa/templates/AutoHoa';
import SortHoaFeeType from './features/hoa/sortHoaFreeType/templates/SortHoaFeeType';
import ThirdPartyProvider from './features/hoa/thirdPartyProvider/templates/ThirdPartyProvider';
import ImportVersion from './features/tenantAdmin/importVersion/templates/ImportVersion';
import QcLogic from './features/tenantAdmin/qcLogic/templates/QcLogic';
import NoteRule from './features/tenantAdmin/noteLogic/templates/NoteLogic';
import ScraperModule from './features/tenantAdmin/scraperModule/templates/ScraperModule';
import RecordAuditForm from './features/tenantAdmin/recordAudit/templates/RecordAudit';
import ErrorLogs from './features/sysAdmin/error/templates/ErrorLogs';
import RegisteredScrapers from './features/tenantAdmin/workerScraper/templates/RegisteredScrapers';
import Code from './features/sysAdmin/code/templates/Code';
import Tenants from './features/sysAdmin/tenant/templates/Tenants';
import Payment from './features/accounting/payment/Payment';
import TurnAroundReport from './features/reports/reports/templates/TurnAroundReport';
import RevenueReport from './features/reports/reports/templates/RevenueReport';
import AggregateUserEfficiencyReport from './features/reports/reports/templates/AggregateUserEfficiencyReport';
import DetailedUserEfficiencyReport from './features/reports/reports/templates/DetailedUserEfficiencyReport';
import AutoVsManualReport from './features/reports/reports/templates/AutovsManualReport';
import AccountsReceivableReport from './features/reports/reports/templates/AccountsReceivableReport';
import FulfillmentCandidateReport from './features/reports/reports/templates/FulfillmentCandidateReport';
import FulfillmentCustomerReport from './features/reports/reports/templates/FulfillmentCustomerReport';
import DailyOrderCountReport from './features/reports/reports/templates/DailyOrderCountReport';
import DailyUpdateReport from './features/reports/reports/templates/DailyUpdateReport';
import ProductAssignmentReport from './features/reports/reports/templates/ProductAssignmentReport';
import Transactions from './features/accounting/fnf/Transactions';
import PartnerPricing from './features/accounting/partnerPricing/PartnerPricing';
import Accounting from './features/accounting/Accounting';
import AddQcLogicForm from './features/tenantAdmin/qcLogic/templates/AddQcLogicForm';
import AddNoteLogic from './features/tenantAdmin/noteLogic/templates/AddNoteLogic';
import UpdateNoteLogic from './features/tenantAdmin/noteLogic/templates/UpdateNoteLogic';
import UpdateScraperModule from './features/tenantAdmin/scraperModule/templates/UpdateScraperModule';
import AddScraperModule from './features/tenantAdmin/scraperModule/templates/AddScraperModule';
import RecordAuditDetailPage from './features/tenantAdmin/recordAudit/templates/RecordAuditDetailPage';
import AddSystemPropertyForm from './features/sysAdmin/systemProperties/AddSystemProperty';
import UpdateCodeForm from './features/sysAdmin/code/templates/UpdateCodeForm';
import AddCodeForm from './features/sysAdmin/code/templates/AddCodeForm';
import UpdateTenant from './features/sysAdmin/tenant/templates/UpdateTenant';
import CollectorDetailPage from './features/data/collector/templates/CollectorDetailPage';
import TaxRoundingConfig from "./features/data/taxRoundingConfig/templates/TaxRoundingConfig";
import HighRiskAccount from "./features/data/highRiskAccount/HighRiskAccount";
import Home from "./features/home/Home";
import ManagementCompanyDetailPage from './features/hoa/managementCompany/template/ManangmentCompanyDetailPage';
import ThirdPartyProviderDetailPage from './features/hoa/thirdPartyProvider/templates/ThirdPartyProviderDetailPage';
import UpdateAutoHoa from './features/hoa/auto-hoa/templates/UpdateAutoHoa';
import CreateAutoHoa from './features/hoa/auto-hoa/templates/CreateAutoHoa';
import AssociationDetailPage from './features/hoa/association/templates/AssociationDetailPage';
import Subdivision from './features/data/subDivision/templates/Subdivision';
import SubdivisionDetailPage from './features/data/subDivision/templates/SubdivisionDetailPage';
import StateCodesDetailPage from './features/data/stateCode/templates/StateCodeDetailPage';
import UpdatedCollectorLink from './features/data/collectorLink/UpdatedCollectorLink';
import CreateCollectorLink from './features/data/collectorLink/CreateCollectorLink';
import UpdateLinkedAccount from './features/data/linkedAccounts/UpdateLinkedAccount';
import CreateLinkedAccounts from './features/data/linkedAccounts/CreateLinkedAccounts';
import Jurisdictions from './features/data/jurisdiction/templates/Jurisdictions';
import Orders from './features/order/Orders';
import CreateOrder from './features/order/wizard/CreateOrder';
import OrderDetailPage from './features/order/detailPage/OrderDetailPage';
import ExternalBillReleases from './features/external/billRelease/BillReleases';
import CreateManagementCompany from './features/hoa/managementCompany/template/CreateManagementCompany';
import CreateAssociation from './features/hoa/association/templates/CreateAssociation';
import CreateThirdPartyProvider from './features/hoa/thirdPartyProvider/templates/CreateThirdPartyProvider';
import CreateCannedNotes from './features/data/cannedNotes/CreateCannedNotes';
import CreateSubdivision from './features/data/subDivision/templates/CreateSubdivision';
import TaxRoll from './features/data/taxRoll/templates/TaxRoll';
import UpdateTaxRoll from './features/data/taxRoll/templates/UpdateTaxRoll';
import Translation from './features/sysAdmin/accountTrans/templates/Translation';
import UpdateAccountTrans from './features/sysAdmin/accountTrans/templates/UpdateAccountTranslationForm';
import CreateAccountTrans from './features/sysAdmin/accountTrans/templates/AddAccountTranslationForm';
import AddJurisdictionForm from './features/data/jurisdiction/templates/AddJurisdictionForm';
import JurisdictionDetailPage from './features/data/jurisdiction/templates/JurisdictionDetailPage';
import AddTaxRoundingConfig from './features/data/taxRoundingConfig/templates/AddTaxRoundingConfig';
import UpdateTaxRoundingConfig from './features/data/taxRoundingConfig/templates/UpdateTaxRoundingConfig';
import CreateCollector from './features/data/collector/templates/CreateCollector';
import HoaEditorDetailPage from './features/order/editor/Hoa/HOAEditor';
import ReOrder from './features/order/wizard/ReOrder';
import CreateStateCodes from './features/data/stateCode/templates/CreateStateCode';
import NationalTaxEditor from "./features/order/nationalEditor/TaxCertificate/NationalTaxEditor";
import TaxEditor from "./features/order/editor/TaxCertificate/TaxEditor";
import {useBaseUrlQuery} from "./features/login/loginPageApi";
import UpdateQcLogicForm from "./features/tenantAdmin/qcLogic/templates/UpdateQcLogicForm";
import Incidents from "./features/accounting/Incidents/Incidents";
import IceFooter from "./components/layout/footer/IceFooter";
import CustomerAccessNotice from "./components/layout/CustomerAccessNotice";


const PublicRoutes = React.memo(() => {
    return (
        <>
            <Outlet />
            <IceFooter />
        </>
    );
});

const PrivateRoutes = () => {
    const dispatch = useDispatch();
    const isUserLoggedIn = useMemo(() => localStorage.getItem("authToken"), []);
    const isAuthenticated = useMemo(() => isUserLoggedIn && !isTokenExpired(), [isUserLoggedIn]);
    const isCollapsed = useSelector((state: any) => state.global.isCollapsed);

    const renderContent = useCallback(() => {
        if (!isAuthenticated) {
            // Capture the attempted path and redirect to login
            dispatch(setRedirectPath(window.location.pathname + window.location.search + window.location.hash));
            localStorage.clear();
            return <Navigate to="/login" />;
        }

        return (
            <div className="flex flex-col">
                <Header />
                <div className="app-content">
                    <SideBar />
                    <div className="flex flex-col flex-1 min-h-screen h-full">
                        <div
                            className={`pt-12 relative min-h-screen bg-text-0 w-100 ${!isCollapsed ? "lg:pl-52 md:pl-52 sm:pl-0" : "pl-14"
                            }`}
                        >
                            <CustomerAccessNotice />
                            <Outlet />
                        </div>
                    </div>
                </div>
            </div>
        );
    }, [dispatch, isAuthenticated, isCollapsed]);

    return renderContent();
};

function App() {
    const dispatch = useDispatch();
    const isCollapsed = useSelector((state: any) => state.global.isCollapsed);
    const error = useSelector((state: any) => state.global.error);
    const baseUrl = `${window.location.host}`;
    const tenantData = useBaseUrlQuery(baseUrl);


    const handleCloseError = useCallback(() => {
        dispatch(clearGlobalError());
    }, [dispatch]);

    useEffect(() => {
        if (!tenantData || tenantData.error) {
            console.warn('API call failed. Setting default favicon.');
            updateIcons(`${process.env.PUBLIC_URL}/defaultFavicon.ico`);
        }
    }, [tenantData]);
    useEffect(() => {
        if (tenantData.data && tenantData.data.faviconId) {
            const faviconUrl = `${process.env.REACT_APP_BASE_URL}/ajax/image/bytes/${tenantData.data.faviconId}`;
            updateIcons(faviconUrl);
        }else {
            // Set default favicon if API data is not available
            updateIcons(`${process.env.PUBLIC_URL}/defaultFavicon.ico`);
        }
    }, [tenantData?.data?.faviconId]);

    const updateIcons = (iconUrl: any) => {
        const iconTypes = [
            { id: 'favicon', rel: 'icon' },
            { id: 'shortcut-icon', rel: 'shortcut icon' },
            { id: 'mask-icon', rel: 'mask-icon', color: '#000000' },
            { id: 'apple-touch-icon', rel: 'apple-touch-icon' },
        ];

        iconTypes.forEach((type) => {
            let iconElement = document.getElementById(type.id) as HTMLLinkElement | null;
            if (iconElement) {
                iconElement.href = iconUrl;
            } else {
                iconElement = document.createElement('link');
                iconElement.id = type.id;
                iconElement.rel = type.rel;
                iconElement.href = iconUrl;
                if (type.color) iconElement.setAttribute('color', type.color);
                document.head.appendChild(iconElement);
            }
        });
    };



    return (
        <Router>
            <ToastContainer
                position="bottom-left"
                autoClose={3000}
                pauseOnHover
                pauseOnFocusLoss
                stacked
                theme='light'
            />
            {error && (
                <div className="flex flex-col">
                    <Header />
                    <div className="app-content">
                        <SideBar />
                        <div className="flex flex-col flex-1 min-h-screen h-full">
                            <div
                                className={`pt-12 relative min-h-screen w-100  ${!isCollapsed ? "lg:pl-52 md:pl-52 sm:pl-0" : "pl-14"}`}>
                                <CustomerAccessNotice />
                                <ErrorPage
                                    statusCode={error.statusCode}
                                    message={error.message}
                                    onClose={handleCloseError}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {!error &&
                <Routes>
                    <Route element={<PublicRoutes />}>
                        {!(localStorage.getItem("authToken") && !isTokenExpired()) && <Route path={AppRoutes.Default.path} element={<LoginPage />} />}
                        <Route path={AppRoutes.Login.path} element={<LoginPage />} />
                        <Route path={AppRoutes.VerifyMfa.path} element={<VerifyMfaForm />} />
                        <Route path={AppRoutes.ForgotPassword.path} element={<ForgotPassword />} />
                        <Route path={AppRoutes.ResetPassword.path} element={<ResetPassword />} />
                        <Route path={AppRoutes.CreatePassword.path} element={<ResetPassword />} />
                        <Route path={AppRoutes.ExternalBillRelease.path} element={<ExternalBillReleases />} />
                    </Route>    

                    <Route element={<PrivateRoutes />}>
                        {(localStorage.getItem("authToken") && !isTokenExpired()) && <Route path={AppRoutes.Default.path} element={<Home />} />}
                        <Route path={AppRoutes.Home.path} element={<Home />} />
                        <Route path={AppRoutes.Order.path} element={<Orders/>}/>
                        <Route path={AppRoutes.CreateOrder.path} element={<CreateOrder/>}/>
                        <Route path={AppRoutes.ReOrder.path} element={<ReOrder/>}/>
                        <Route path={AppRoutes.OrderDetailPage.path} element={<OrderDetailPage/>}/>
                        <Route path={AppRoutes.TaxOrderEditor.path} element={<TaxEditor/>}/>
                        <Route path={AppRoutes.TaxOrderNationalEditor.path} element={<NationalTaxEditor/>}/>
                        <Route path={AppRoutes.HoaOrderEditor.path} element={<HoaEditorDetailPage/>}/>
                        <Route path={AppRoutes.HoaContactEditor.path} element={<HoaEditorDetailPage/>}/>
                        <Route path={AppRoutes.Users.path} element={<Users />} />
                        <Route path={AppRoutes.CreateUser.path} element={<CreateUser />} />
                        <Route path={AppRoutes.UpdateUser.path} element={<UpdateUser />} />
                        <Route path={AppRoutes.Roles.path} element={<Roles />} />
                        <Route path={AppRoutes.CreateRole.path} element={<CreateRole />} />
                        <Route path={AppRoutes.UpdateRole.path} element={<UpdateRole />} />
                        <Route path={AppRoutes.Teams.path} element={<Teams />} />
                        <Route path={AppRoutes.CreateTeam.path} element={<CreateTeam />} />
                        <Route path={AppRoutes.TeamDetailPage.path} element={<TeamDetailPage />} />
                        <Route path={AppRoutes.Customers.path} element={<Customers />} />
                        <Route path={AppRoutes.CreateCustomer.path} element={<CreateCustomerForm />} />
                        <Route path={AppRoutes.CustomerDetailPage.path} element={<CustomerDetailPage />} />
                        <Route path={AppRoutes.BranchDetailPage.path} element={<BranchDetailPage />} />
                        <Route path={AppRoutes.SystemProperties.path} element={<SystemProperties />} />
                        <Route path={AppRoutes.UpdateSystemProperties.path} element={<UpdateSystemProperty />} />
                        <Route path={AppRoutes.CreateSystemProperties.path} element={<AddSystemPropertyForm />} />
                        <Route path={AppRoutes.CannedNotes.path} element={<CannedNotes />} />
                        <Route path={AppRoutes.UpdateCannedNote.path} element={<UpdateCannedNote />} />
                        <Route path={AppRoutes.CreateCannedNotes.path} element={<CreateCannedNotes/>}/>
                        <Route path={AppRoutes.Collector.path} element={<Collectors />} />
                        <Route path={AppRoutes.Counties.path} element={<Counties />} />
                        <Route path={AppRoutes.CreateCounty.path} element={<CreateCounty />} />
                        <Route path={AppRoutes.UpdateCounty.path} element={<UpdateCounty />} />
                        <Route path={AppRoutes.Jurisdiction.path} element={<Jurisdictions/>}/>
                        <Route path={AppRoutes.StateCode.path} element={<StateCodes />} />
                        <Route path={AppRoutes.CreateStateCodes.path} element={<CreateStateCodes />} />
                        <Route path={AppRoutes.MetroAreas.path} element={<MetroAreas />} />
                        <Route path={AppRoutes.CreateMetroArea.path} element={<CreateMetroArea />} />
                        <Route path={AppRoutes.UpdateMetroArea.path} element={<UpdateMetroArea />} />
                        <Route path={AppRoutes.PartnerPricing.path} element={<PartnerPricing />} />
                        <Route path={AppRoutes.VendorPricing.path} element={<VendorPricing />} />
                        <Route path={AppRoutes.RevenueEvents.path} element={<RevenueEvents />} />
                        <Route path={AppRoutes.Incidents.path} element={<Incidents />} />
                        <Route path={AppRoutes.CreateVendorPricing.path} element={<CreateVendorPricing />} />
                        <Route path={AppRoutes.UpdateVendorPricing.path} element={<UpdateVendorPricing />} />
                        <Route path={AppRoutes.FollowUpTypes.path} element={<FollowUpTypes />} />
                        <Route path={AppRoutes.CreateFollowUpType.path} element={<CreateFollowUpType />} />
                        <Route path={AppRoutes.UpdateFollowUpType.path} element={<UpdateFollowUpType />} />
                        <Route path={AppRoutes.States.path} element={<States />} />
                        <Route path={AppRoutes.AppraisalRolls.path} element={<AppraisalRoll />} />
                        <Route path={AppRoutes.UpdateAppraisalRolls.path} element={<AppraisalRollDetailPage />} />
                        <Route path={AppRoutes.BillRelease.path} element={<BillReleases />} />
                        <Route path={AppRoutes.CreateBillRelease.path} element={<CreateBillRelease />} />
                        <Route path={AppRoutes.UpdateBillRelease.path} element={<UpdateBillRelease />} />
                        <Route path={AppRoutes.CreateState.path} element={<CreateState />} />
                        <Route path={AppRoutes.UpdateState.path} element={<UpdateState />} />
                        <Route path={AppRoutes.Profile.path} element={<Profile />} />
                        <Route path={AppRoutes.LinkedAccount.path} element={<LinkedAccounts />} />
                        <Route path={AppRoutes.UpdateLinkedAccount.path} element={<UpdateLinkedAccount/>}/>
                        <Route path={AppRoutes.CreateLinkedAccount.path} element={<CreateLinkedAccounts/>}/>
                        <Route path={AppRoutes.VerifiedHighRiskAccount.path} element={<HighRiskAccountVerified />} />
                        <Route path={AppRoutes.CollectorLink.path} element={<CollectorLink />} />
                        <Route path={AppRoutes.UpdateCollectorLink.path} element={<UpdatedCollectorLink/>}/>
                        <Route path={AppRoutes.CreateCollectorLink.path} element={<CreateCollectorLink/>}/>
                        <Route path={AppRoutes.ReportHistory.path} element={<ReportsHistory />} />
                        <Route path={AppRoutes.OrderEvents.path} element={<OrderEvent />} />
                        <Route path={AppRoutes.Report.path} element={<TurnAroundReport />} />
                        <Route path={AppRoutes.Association.path} element={<Associations />} />
                        <Route path={AppRoutes.CreateAssociation.path} element={<CreateAssociation/>}/>
                        <Route path={AppRoutes.ManagementCompany.path} element={<ManagementCompany />} />
                        <Route path={AppRoutes.CreateManagementCompany.path} element={<CreateManagementCompany/>}/>
                        <Route path={AppRoutes.AutoHoa.path} element={<AutoHoa />} />
                        <Route path={AppRoutes.SortFeeType.path} element={<SortHoaFeeType />} />
                        <Route path={AppRoutes.ThirdPartyProvider.path} element={<ThirdPartyProvider />} />
                        <Route path={AppRoutes.CreateThirdPartyProvider.path} element={<CreateThirdPartyProvider />}/>
                        <Route path={AppRoutes.ImportVersion.path} element={<ImportVersion />} />
                        <Route path={AppRoutes.QCLogics.path} element={<QcLogic />} />
                        <Route path={AppRoutes.NoteLogics.path} element={<NoteRule />} />
                        <Route path={AppRoutes.ScrapperModule.path} element={<ScraperModule />} />
                        <Route path={AppRoutes.RecordAudit.path} element={<RecordAuditForm />} />
                        <Route path={AppRoutes.ErrorLogs.path} element={<ErrorLogs />} />
                        <Route path={AppRoutes.RegisteredScrapper.path} element={<RegisteredScrapers />} />
                        <Route path={AppRoutes.Codes.path} element={<Code />} />
                        <Route path={AppRoutes.Tenants.path} element={<Tenants />} />
                        <Route path={AppRoutes.Payment.path} element={<Payment />} />
                        <Route path={AppRoutes.TurnAroundReport.path} element={<TurnAroundReport />} />
                        <Route path={AppRoutes.CountyReport.path} element={<CountyReport />} />
                        <Route path={AppRoutes.RevenueReport.path} element={<RevenueReport />} />
                        <Route path={AppRoutes.AggregateUserEfficiencyReport.path} element={<AggregateUserEfficiencyReport />} />
                        <Route path={AppRoutes.DetailedUserEfficiencyReport.path} element={<DetailedUserEfficiencyReport />} />
                        <Route path={AppRoutes.AutoVsManualReport.path} element={<AutoVsManualReport />} />
                        <Route path={AppRoutes.AccountsReceivableReport.path} element={<AccountsReceivableReport />} />
                        <Route path={AppRoutes.FulfillmentCandidateReport.path} element={<FulfillmentCandidateReport />} />
                        <Route path={AppRoutes.FullfillmentCustomerReportApiQuery.path} element={<FulfillmentCustomerReport />} />
                        <Route path={AppRoutes.DailyOrderCountReport.path} element={<DailyOrderCountReport />} />
                        <Route path={AppRoutes.DailyUpdateReport.path} element={<DailyUpdateReport />} />
                        <Route path={AppRoutes.ProductAssignmentReport.path} element={<ProductAssignmentReport />} />
                        <Route path={AppRoutes.Transactions.path} element={<Transactions />} />
                        <Route path={AppRoutes.Accounting.path} element={<Accounting />} />
                        <Route path={AppRoutes.UpdateQcLogic.path} element={<UpdateQcLogicForm />} />
                        <Route path={AppRoutes.CreateQcLogic.path} element={<AddQcLogicForm />} />
                        <Route path={AppRoutes.CreateNoteLogics.path} element={<AddNoteLogic />} />
                        <Route path={AppRoutes.UpdateNoteLogics.path} element={<UpdateNoteLogic />} />
                        <Route path={AppRoutes.UpdateScapperMpdule.path} element={<UpdateScraperModule />} />
                        <Route path={AppRoutes.CreateScapperMpdule.path} element={<AddScraperModule />} />
                        <Route path={AppRoutes.UpdateRecordAudit.path} element={<RecordAuditDetailPage />} />
                        <Route path={AppRoutes.UpdateCodes.path} element={<UpdateCodeForm />} />
                        <Route path={AppRoutes.CreateCodes.path} element={<AddCodeForm />} />
                        <Route path={AppRoutes.UpdateTenants.path} element={<UpdateTenant/>}/>
                        <Route path={AppRoutes.CollectorDetailPage.path} element={<CollectorDetailPage/>}/>
                        <Route path={AppRoutes.HighRiskAccount.path} element={<HighRiskAccount/>}/>
                        <Route path={AppRoutes.TaxRoundingConfig.path} element={<TaxRoundingConfig/>}/>
                        <Route path={AppRoutes.UpdateManagementCompany.path} element={<ManagementCompanyDetailPage/>}/>
                        <Route path={AppRoutes.UpdateThirdPartyProvider.path} element={<ThirdPartyProviderDetailPage/>}/>
                        <Route path={AppRoutes.UpdateAutoHoa.path} element={<UpdateAutoHoa/>}/>
                        <Route path={AppRoutes.CreateAutoHoa.path} element={<CreateAutoHoa/>}/>
                        <Route path={AppRoutes.UpdateAssociation.path} element={<AssociationDetailPage/>}/>
                        <Route path={AppRoutes.Subdivision.path} element={<Subdivision/>}/>
                        <Route path={AppRoutes.UpdateSubDivision.path} element={<SubdivisionDetailPage/>}/>
                        <Route path={AppRoutes.CreateSubDivision.path} element={<CreateSubdivision/>}/>
                        <Route path={AppRoutes.UpdateStateCode.path} element={<StateCodesDetailPage/>}/>
                        <Route path={AppRoutes.TaxRoll.path} element={<TaxRoll/>}/>
                        <Route path={AppRoutes.UpdateTaxRoll.path} element={<UpdateTaxRoll/>}/>
                        <Route path={AppRoutes.AccountTranslations.path} element={<Translation/>}/>
                        <Route path={AppRoutes.UpdateAccountTranslations.path} element={<UpdateAccountTrans/>}/>
                        <Route path={AppRoutes.CreateAccountTranslations.path} element={<CreateAccountTrans/>}/>
                        <Route path={AppRoutes.createJurisdiction.path} element={<AddJurisdictionForm />}/>
                        <Route path={AppRoutes.UpdateJurisdiction.path} element={<JurisdictionDetailPage />}/>
                        <Route path={AppRoutes.CreateTaxRoundingConfig.path} element={<AddTaxRoundingConfig/>}/>
                        <Route path={AppRoutes.UpdateTaxRoundingConfig.path} element={<UpdateTaxRoundingConfig/>}/>
                        <Route path={AppRoutes.CreateCollector.path} element={<CreateCollector/>}/>
                        <Route path={"*"} element={<ErrorPage statusCode={404}
                            message="Oops! The page you're looking for does not exist."
                            onClose={handleCloseError} />} />
                    </Route>
                </Routes>
            }
        </Router>
    );
}

export default App;
